import { render, staticRenderFns } from "./HomeStatistics.vue?vue&type=template&id=6e71347f&scoped=true&lang=pug"
import script from "./HomeStatistics.vue?vue&type=script&lang=js"
export * from "./HomeStatistics.vue?vue&type=script&lang=js"
import style0 from "./HomeStatistics.vue?vue&type=style&index=0&id=6e71347f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71347f",
  null
  
)

export default component.exports